import React, { FC, useEffect } from 'react'

import { getString } from 'data'

import { media } from '../../style/media'
import { HeroBlock, IntroCarouselBlockPublic } from '../../components/ContentfulBlock'
import { getLocale, localeToRegion } from '../../dataImplementation/viewingRegionWeb'
import { Carousel, Container, Content, MobileAppsSplash, Spacer, PageLoader } from '../../components'
import { ContentfulBlock } from '../../components/ContentfulBlock/types'
import { HomePageProps } from './types'
import { H3Header } from '../../components/typography'

export const HomePublic: FC<HomePageProps> = ({ currentPage, doSpecificPageFetch }) => {
  const content = currentPage?.content?.fields
  const viewingRegion = localeToRegion(getLocale())

  useEffect(() => {
    doSpecificPageFetch({
      slugName: 'home-page-logged-out',
      ...(viewingRegion && { viewingRegion: `EN_${viewingRegion}` }),
    })
  }, [doSpecificPageFetch, viewingRegion])

  return currentPage ? (
    <>
      <style jsx>{`
        .styles-preposition-carousel :global(.text-panel) {
          padding: 15px 20px;
          align-items: center;
          text-align: center;
        }
        .styles-preposition-carousel :global(.text-panel h2) {
          font-style: unset;
          text-align: unset;
        }

        @media ${media.tabletAndHigher} {
          .styles-preposition-carousel :global(.text-panel) {
            padding: 20px 22px;
            align-items: unset;
            text-align: unset;
          }
          .styles-preposition-carousel :global(.text-panel h2) {
            text-align: unset;
          }
        }

        @media ${media.desktopAndHigher} {
          .styles-preposition-carousel :global(.text-panel) {
            padding: 40px 55px;
          }
        }
        @media ${media.hiResDesktop} {
          .styles-preposition-carousel :global(.text-panel) {
            padding: 40px 60px;
          }
        }
      `}</style>
      {content?.topHero && <HeroBlock fields={content.topHero.fields} fixedAspectRatio testId="main-hero" />}
      {content?.propositionCarousel && (
        <Container>
          <Spacer size="large" />
          <H3Header
            textAlign="center"
            weight={600}
            marginTop={{ mobile: 0, tablet: 0, desktop: 0 }}
            marginBottom={{ mobile: 0, tablet: 0, desktop: 0 }}
            fontSize={{ mobile: 28, tablet: 28, desktop: 40 }}
          >
            {getString('home.propositionCarousel.title')}
          </H3Header>
          <div className="styles-preposition-carousel">
            <Carousel
              items={content?.propositionCarousel?.fields.heroBlocks?.map((block: ContentfulBlock<any>) => (
                <HeroBlock fields={block.fields} />
              ))}
            />
          </div>
        </Container>
      )}
      <Spacer size="large" />
      {content?.introCarousel2 && <IntroCarouselBlockPublic fields={content.introCarousel2.fields} />}
      <Spacer size="medium" />
      {content?.introCarousel1 && <IntroCarouselBlockPublic fields={content.introCarousel1.fields} />}
      <Spacer size="small" />
      <Content>
        <MobileAppsSplash />
      </Content>
    </>
  ) : (
    <PageLoader />
  )
}
